import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import SliderWithThumb from "./SliderWithThumb";
import { Utils } from "../utils";

interface InputProps {
  show: boolean;
  onHide: () => void;
  data: any;
}

const AdDetailsPopup: React.FC<InputProps> = ({ show, onHide, data }) => {
  const [showSlider, setShowSlider] = useState(false);
  const slidesData = data?.images?.map((k: string) => {
    return { img: k };
  });

  return (
    <Modal
      className="disputeModal detailModal"
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="text-start">
        <div className="d-flex justify-content-between">
          <h3>Details of the Artwork</h3>
          <img
            src="/assets/imgs/plus.svg"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setShowSlider(false);
              if (!showSlider) onHide();
            }}
            alt=""
          />
        </div>
        <hr />

        {showSlider ? (
          <SliderWithThumb slidesData={slidesData} dir="horizontal" />
        ) : (
          <div className="row">
            <div className="col-md-12 mb-3">
              <div className="d-flex gap-3">
                <div
                  className="galleryCount"
                  onClick={() => setShowSlider(true)}
                >
                  <span>+{data?.images?.length}</span>
                  <div className="countOverlay"></div>
                  <img
                    src={data?.images?.[0] || ""}
                    alt=""
                    style={{ height: 42, width: 42 }}
                  />
                </div>
                <div>
                  <h2>Title:</h2>
                  <p>{data?.title}</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <h2>Bids recieved:</h2>
              <p className="primaryColor">
                {Utils.formatToNumber(data?.bids || 0)}
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <h2>Opening price:</h2>
              <p className="primaryColor">
                {Utils.formatToCurrency(data?.price)}
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <h2>Total views:</h2>
              <p className="primaryColor">
                {Utils.formatToNumber(data?.views)} views
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <h2>Time left in closing:</h2>
              <p className="primaryColor">
                {Utils.formatFromNow(data?.biddingEnds)}
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <h2>Listing date:</h2>
              <p className="primaryColor">
                {Utils.formatDate(data?.createdAt)}
              </p>
            </div>
            {data?.categoryId?.name && (
              <div className="col-md-6 mb-3">
                <h2>Category:</h2>
                <p className="primaryColor">{data?.categoryId?.name || "-"}</p>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AdDetailsPopup;
